export default {
    'edit-classification': 'Edit classification',
    'add-new-classification': 'Add new classification'
}